/*
 *
 * SystemPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 03-Oct-2024
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import * as userAction from 'Store/actions/user'
import SystemPopUp from './SystemPopUp'
import { doLocalLoading } from 'Store/actions/loading'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(userAction, dispatch),

  getUserProfile: () => {
    dispatch(userAction.doGetUserProfile())
    dispatch(doPopup(''))
  },

  logout: () => {
    dispatch(userAction.doLogout())
    dispatch(doPopup(''))
    dispatch(doLocalLoading({ id: 'PortalLayoutLoader', value: true }))
  },

  closePopup: () => {
    dispatch(doPopup(''))
  }
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SystemPopUp)
